import { apiCall } from "./common/base.service";
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from '../config/dictionary';

class TypeService {
    getPermissions = (username, action) => {
        return permission.validPermission(
            process.env.REACT_APP_TRANSACTION_TYPE,
            username,
            process.env.REACT_APP_SYSTEM_CODE, action);

    }

    disable = async (list, username) => {
        const url = `${config.data.providers.conceptMaster.url}delete`

        const validPermission = await type.getPermissions(username, dictionary.configApp.action.delete)
        const error = validPermission?.response?.data?.error

        return error ? validPermission : apiCall("delete", url, list)
    }
    update = async (data) => {
        const url = `${config.data.providers.conceptMaster.url}update`
        const validPermission = await type.getPermissions(data.createdBy, dictionary.configApp.action.edit)
        const error = validPermission?.response?.data?.error
        return error ? validPermission : apiCall("put", url, data)
    }
    save = async (data) => {
        const url = `${config.data.providers.conceptMaster.url}register`
        const validPermission = await type.getPermissions(data.createdBy, dictionary.configApp.action.add)
        const error = validPermission?.response?.data?.error
        return error ? validPermission : apiCall("post", url, data)
    }
    getTypes = concept => {
        const url = `${config.data.providers.conceptMaster.url}find_by_concept_id/${concept}`
        return apiCall("get", url)
    }
    getTypesByConceptCode = concept => {
        const url = `${config.data.providers.conceptMaster.url}find_by_concept_code/${concept}`
        return apiCall("get", url)
    }
}

const type = new TypeService()
export default type